export const InstantBook = {
  OFF: "OFF",
  REQUEST_TO_BOOK: "REQUEST_TO_BOOK",
} as const;
